export const CHECKOUT_URL = 'https://coreano-visual.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#oferta'

export const PRICE = '$19.990'
export const PRICE_ALT = '$19.990'
export const BONUS_VALUE = '$116.135'

export const BRAND = 'CM DIGITAL PRO'
export const PRODUCT = 'COREANO VISUAL™'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mbyC6JGLzqTLakrEdeVvVf/Imagen_de_Codex_4_sept_2026,_23_19_17.png'

export const ROUTE = [
  'Hangul',
  'Pronunciación',
  'Vocabulario',
  'Frases',
  'Vida Real',
  'Comprensión',
]

export const questions = [
  '¿Por dónde empiezo?',
  '¿Cómo puedo aprender a leer Hangul?',
  '¿Cómo se pronuncian los sonidos coreanos?',
  '¿Qué vocabulario debería aprender primero?',
  '¿Cómo construyo mis primeras frases?',
  '¿Cómo puedo empezar a entender el coreano que escucho?',
]

export const goals = [
  'Reconocer y comenzar a leer Hangul.',
  'Comprender los sonidos esenciales del coreano.',
  'Aprender vocabulario útil mediante asociaciones visuales.',
  'Construir tus primeras frases sencillas.',
  'Comprender expresiones para situaciones cotidianas.',
  'Empezar a reconocer palabras y patrones frecuentes cuando escuchas coreano.',
  'Continuar aprendiendo con una ruta mucho más clara.',
]

export const systemFeatures = [
  'Explicaciones fáciles de seguir',
  'Ejemplos visuales',
  'Vocabulario práctico',
  'Ejercicios educativos',
  'Frases cotidianas',
  'Recursos de práctica',
]

export const tomos = [
  {
    title: 'TOMO 1 — HANGUL VISUAL™',
    desc: 'Aprende la lógica del alfabeto coreano, reconoce consonantes y vocales, comprende cómo se construyen los bloques silábicos y descubre las bases del 받침.',
    extraDesc:
      'Empieza a transformar símbolos desconocidos en letras que puedes reconocer y comenzar a leer.',
    tag: 'Observa. Reconoce. Lee.',
  },
  {
    title: 'TOMO 2 — PRONUNCIACIÓN COREANA FÁCIL™',
    desc: 'Comprende los sonidos esenciales del coreano y las diferencias que pueden resultar difíciles para un hispanohablante.',
    extraDesc:
      'Aprende a evitar errores frecuentes y a desarrollar una base más clara para leer y pronunciar.',
    tag: 'Escucha. Distingue. Pronuncia.',
  },
  {
    title: 'TOMO 3 — VOCABULARIO COREANO VISUAL™',
    desc: 'Aprende vocabulario esencial organizado por situaciones, categorías y asociaciones visuales.',
    extraDesc:
      'Descubre palabras relacionadas con personas, comida, lugares, acciones, emociones, tiempo, viajes y vida cotidiana.',
    tag: 'Mira. Asocia. Recuerda.',
  },
  {
    title: 'TOMO 4 — TUS PRIMERAS FRASES EN COREANO™',
    desc: 'Descubre la lógica básica de las oraciones coreanas, partículas esenciales y estructuras sencillas para empezar a expresar tus propias ideas.',
    extraDesc: 'Aprende a pasar de palabras aisladas a tus primeras frases.',
    tag: 'Comprende. Construye. Expresa.',
  },
  {
    title: 'TOMO 5 — COREANO PARA LA VIDA REAL™',
    desc: 'Aprende expresiones básicas para saludarte, presentarte, hablar de gustos, pedir comida, comprar, viajar, preguntar direcciones y desenvolverte en situaciones cotidianas.',
    extraDesc:
      'Practica con ejemplos y pequeñas situaciones creadas para principiantes.',
    tag: 'Aprende. Practica. Comunica.',
  },
  {
    title: 'TOMO 6 — ENTIENDE EL COREANO QUE ESCUCHAS™',
    desc: 'Entrena tu reconocimiento de palabras, patrones y expresiones frecuentes para comenzar a comprender mejor el coreano que escuchas.',
    extraDesc:
      'Aprende a detectar elementos conocidos sin sentir que necesitas comprender cada palabra.',
    tag: 'Escucha. Detecta. Comprende.',
  },
]

export const bonuses = [
  {
    title: 'BONO 1 — HANGUL EXPRESS™',
    subtitle: 'Guía Visual Rápida para Aprender a Leer Coreano Desde Cero',
    shortTitle: 'Hangul Express™',
    desc: 'Utiliza una referencia visual práctica para reconocer consonantes, vocales, bloques silábicos y las bases del Hangul mientras avanzas en tu aprendizaje.',
    tag: 'Observa. Reconoce. Lee.',
    value: '$18.099',
  },
  {
    title: 'BONO 2 — +100 FICHAS VISUALES DE COREANO PRÁCTICO™',
    subtitle: '',
    shortTitle: '+100 Fichas Visuales de Coreano Práctico™',
    desc: 'Aprende y repasa más de 100 palabras y expresiones esenciales mediante Hangul, significado, asociaciones visuales y pequeñas frases de contexto.',
    tag: 'Mira. Asocia. Recuerda.',
    value: '$43.739',
  },
  {
    title: 'BONO 3 — K-DRAMA & K-POP PHRASEBOOK™',
    subtitle: '',
    shortTitle: 'K-Drama & K-Pop Phrasebook™',
    desc: 'Descubre frases y expresiones frecuentes para empezar a reconocer mejor el coreano que escuchas en conversaciones, entretenimiento y contenido coreano.',
    tag: 'Escucha. Reconoce. Comprende.',
    value: '$18.099',
  },
  {
    title: 'BONO 4 — RETO COREANO EN 30 DÍAS™',
    subtitle: '',
    shortTitle: 'Reto Coreano en 30 Días™',
    desc: 'Sigue una ruta diaria de pequeñas prácticas para reforzar Hangul, pronunciación, vocabulario, frases y comprensión sin preguntarte qué estudiar cada día.',
    tag: 'Practica. Avanza. Mantén el hábito.',
    value: '$18.099',
  },
  {
    title: 'BONO 5 — MI PRIMER CUADERNO DE COREANO™',
    subtitle: '',
    shortTitle: 'Mi Primer Cuaderno de Coreano™',
    desc: 'Practica activamente mediante ejercicios de Hangul, vocabulario, construcción de frases, situaciones cotidianas y actividades de escritura.',
    tag: 'Escribe. Practica. Activa.',
    value: '$18.099',
  },
]

export const routeSteps = [
  { icon: '✨', text: 'Empiezas desde cero.' },
  { icon: '🔤', text: 'Comprendes Hangul.' },
  { icon: '👀', text: 'Reconoces vocabulario.' },
  { icon: '💬', text: 'Construyes frases.' },
  { icon: '🗣️', text: 'Practicas situaciones cotidianas.' },
  { icon: '👂', text: 'Empiezas a reconocer el coreano que escuchas.' },
]

export const includedTomos = [
  'Tomo 1 — Hangul Visual™',
  'Tomo 2 — Pronunciación Coreana Fácil™',
  'Tomo 3 — Vocabulario Coreano Visual™',
  'Tomo 4 — Tus Primeras Frases en Coreano™',
  'Tomo 5 — Coreano para la Vida Real™',
  'Tomo 6 — Entiende el Coreano que Escuchas™',
]

export const offerHighlights = [
  'Hangul Visual',
  'Pronunciación',
  'Vocabulario Esencial',
  'Primeras Frases',
  'Coreano para la Vida Real',
  'Comprensión Inicial',
]

export const testimonials = [
  {
    name: 'Camila Restrepo',
    role: 'Estudiante universitaria, 21 años',
    place: 'Medellín, Colombia',
    text: 'Llevaba dos años viendo k-dramas con subtítulos y sintiendo que nunca iba a poder leer nada. Con el Tomo 1 entendí que el Hangul tiene lógica: consonantes, vocales y bloques. A la semana ya leía los carteles de las series sin buscar la traducción y eso me motivó como nada antes.',
  },
  {
    name: 'Valentina Soto',
    role: 'Diseñadora gráfica, 26 años',
    place: 'Santiago, Chile',
    text: 'Tenía tres apps abandonadas y una libreta con vocabulario suelto. Lo que me ordenó fue la ruta: primero Hangul, después pronunciación, después vocabulario. Las fichas visuales del Bono 2 me hicieron recordar palabras sin repetirlas mil veces porque las asocio con imágenes.',
  },
  {
    name: 'Sofía Gutiérrez',
    role: 'Auxiliar administrativa, 24 años',
    place: 'Ciudad de México, México',
    text: 'Siempre pensé que la pronunciación coreana era imposible para mí. El Tomo 2 explica justo las diferencias que nos cuestan a los hispanohablantes y por fin dejé de confundir sonidos parecidos. Ahora repito frases en voz alta sin sentir vergüenza.',
  },
  {
    name: 'Antonella Ferreyra',
    role: 'Profesora de nivel inicial, 29 años',
    place: 'Rosario, Argentina',
    text: 'Compré pensando en mi viaje a Seúl y el Tomo 5 fue exactamente lo que necesitaba: saludar, pedir comida, preguntar direcciones y comprar. Practiqué las situaciones del cuaderno todas las noches y llegué al viaje entendiendo mucho más de lo que esperaba.',
  },
  {
    name: 'Daniela Peña',
    role: 'Community manager, 32 años',
    place: 'Lima, Perú',
    text: 'El Reto de 30 días me salvó de abandonar otra vez. No tenía que decidir qué estudiar cada día, solo abrir y practicar. Hoy escucho k-pop y reconozco expresiones completas del Phrasebook; ya no siento que el coreano sea un idioma inalcanzable.',
  },
]

export const faqs = [
  {
    q: '¿Es un producto físico?',
    a: 'No. Es un producto educativo 100% digital con acceso después de la compra.',
  },
  {
    q: '¿Para quién es?',
    a: 'Para principiantes y personas que desean construir una base inicial en coreano siguiendo una ruta visual, sencilla y estructurada.',
  },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El recorrido comienza desde cero con Hangul y los fundamentos esenciales.',
  },
  {
    q: '¿Voy a aprender a leer Hangul?',
    a: 'Aprenderás la lógica básica del Hangul, consonantes, vocales, construcción de bloques silábicos y elementos iniciales necesarios para comenzar a leer.',
  },
  {
    q: '¿Incluye ejercicios prácticos?',
    a: 'Sí. Encontrarás ejercicios, actividades, vocabulario, frases, retos y recursos para reforzar lo aprendido.',
  },
  {
    q: '¿Los 5 bonos tienen un costo adicional?',
    a: 'No. Los 5 bonos, con un valor de referencia conjunto de $116.135, están incluidos gratis con tu compra durante esta oferta.',
  },
  {
    q: '¿Cuánto cuesta el sistema completo?',
    a: 'El precio especial indicado para esta oferta es de $19.990 en un único pago.',
  },
  {
    q: '¿Voy a hablar coreano con fluidez?',
    a: 'No se promete fluidez. El sistema está diseñado para ayudarte a construir una base inicial sólida en Hangul, pronunciación, vocabulario, frases y comprensión básica.',
  },
  {
    q: '¿El contenido sirve si nunca estudié idiomas?',
    a: 'Sí. El recorrido está diseñado para comenzar desde los conceptos fundamentales y avanzar progresivamente.',
  },
  {
    q: '¿Cómo recibiré el producto?',
    a: 'Obtendrás acceso digital después de completar tu compra.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Puedes contactar a CM DIGITAL PRO en soportescmdigital@gmail.com.',
  },
]

export const purchaseAlerts = [
  { name: 'Emily Whitmore', city: 'Manchester', country: 'Reino Unido' },
  { name: 'Chloe Callaghan', city: 'Toronto', country: 'Canadá' },
  { name: 'Madison Turner', city: 'Phoenix', country: 'Estados Unidos' },
  { name: 'Ruby Bradshaw', city: 'Brisbane', country: 'Australia' },
  { name: 'Hannah Reid', city: 'Glasgow', country: 'Reino Unido' },
  { name: 'Olivia Kowalski', city: 'Calgary', country: 'Canadá' },
  { name: 'Grace Foster', city: 'Austin', country: 'Estados Unidos' },
  { name: 'Isla Hollis', city: 'Perth', country: 'Australia' },
  { name: 'Sophie Fletcher', city: 'Birmingham', country: 'Reino Unido' },
  { name: 'Amelia Trembley', city: 'Vancouver', country: 'Canadá' },
  { name: 'Ava Miller', city: 'Denver', country: 'Estados Unidos' },
  { name: 'Zoe Sherwood', city: 'Melbourne', country: 'Australia' },
]
